<template>
  <div id="main-banner" class="multi-banner swiper-container" v-on-display="{sectionInfo, context: this}">
    <template v-if="cellList.length > 0">
      <div class="swiper-wrapper" ref="multi-banner">
        <div v-for="(cell, index) in cellList" :key="index" class="swiper-slide component-list">
          <a>
            <img :src="url(cell)" :alt="getTitle(cell)"/>
          </a>
        </div>
      </div>
      <div class="main01-nav">
        <button @click="clickSwiperButton()" class="ico-play">
          <img v-if="isPlay" src="../../../assets/images/common/ico-pause-purple.png" alt="">
          <img v-else src="../../../assets/images/common/ico-play-purple.png" alt="">
        </button>
        <div class="swiper-pagination"></div>
      </div>
      <div class="swiper-button-prev"></div>
      <div class="swiper-button-next"></div>
    </template>
  </div>
</template>

<script>
import _ from 'lodash'
import fp from 'lodash/fp'
import Swiper from '@/mixins/swiper'
import CellMixin from '@/mixins/cell.mixin'
import { fetchOnContent } from '@/common/utils/request.common'
import { getBand, getCellEventObject, getCellList } from '@/common/utils/gnb.fp'
import { onDisplay } from '@/common/resources/directives'

import { bannerLink } from '@/common/utils/common'
import { ON_CLICK_CELL } from '@/common/resources/const'
export default {
  name: 'TemplateMultiBanner',
  mixins: [
    Swiper,
    CellMixin
  ],
  directives: {
    onDisplay
  },
  props: {
    sectionInfo: {
      type: Object
    }
  },
  data () {
    return {
      isPlay: true,
      cellList: [],
      bandInfo: null,
      swiperOptions: {
        autoplay: 3500,
        autoplayDisableOnInteraction: false,
        pagination: '.swiper-pagination',
        paginationType: 'bullets',
        paginationClickable: true,
        centeredSlides: true,
        slidesPerView: 'auto',
        loop: true,
        nextButton: '.swiper-button-prev',
        prevButton: '.swiper-button-next',
        a11y: true,
        onClick: this.onClickProcessor,
        onTouchEnd: this.onClickProcessor
      }
    }
  },
  methods: {
    onClickProcessor (swiper) {
      const idx = _.get(swiper, ['clickedSlide', 'dataset', 'swiperSlideIndex'], '')
      if (idx !== '') {
        const { onClick, onNavigation } = fp.flow(fp.get('event_list'), getCellEventObject)(this.cellList[idx])
        this.$events.$emit(ON_CLICK_CELL, onClick)
        const url = _.get(onNavigation, 'url', '')
        bannerLink(url)
      }
    },
    url (cell) {
      return location.protocol + '//' + _.get(cell, 'thumbnail', '')
    },
    clickSwiperButton () {
      if (this.isPlay) {
        this.swiper.stopAutoplay()
      } else {
        this.swiper.startAutoplay()
      }
      this.isPlay = !this.isPlay
    },
    async setData () {
      const response = await fetchOnContent(this.sectionInfo)
      this.bandInfo = getBand(response)
      this.cellList = getCellList(response)
      this.initSwiperFromEl(this.$refs.multiBanner)
    },
    getTitle (cell) {
      return _.get(cell, ['title_list', '0', 'text'], '')
    }
  },
  created () {
    this.setData()
  },
  beforeDestroy () {
    this.swiper && this.swiper.destroy && this.swiper.destroy()
  }
}
</script>
<style scoped>
  .multi-banner {
    min-height: 530px;
  }
</style>
